import type { ITransaction } from "../context/TransactionsContext";
import confetti from "canvas-confetti";

export const formatEuro = (value: number) =>
  new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
  }).format(value);

export const currentMonthTransactionList = (transactions: ITransaction[]) => {
  const currentMonth = new Date().toISOString().slice(0, 7);

  const filteredTransactionList = transactions.filter(
    (transaction: ITransaction) => transaction.date.startsWith(currentMonth)
  );

  return filteredTransactionList;
};

export function formatMonthYear(monthStr: string): string {
  const [year, month] = monthStr.split("-");
  const date = new Date(Number(year), Number(month) - 1);
  return new Intl.DateTimeFormat("de-DE", {
    year: "numeric",
    month: "long",
  }).format(date);
}

export const getTransactionListDate = (date: Date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  return `${year}-${month}`;
};

export const shootLocalConfetti = (canvas: HTMLCanvasElement) => {
  const myConfetti = confetti.create(canvas, { resize: true, useWorker: true });

  const defaults = {
    spread: 60,
    startVelocity: 45,
    ticks: 250,
    zIndex: 9999,
  };

  myConfetti({
    ...defaults,
    angle: 60,
    origin: { x: 0, y: 1 },
  });

  myConfetti({
    ...defaults,
    angle: 120,
    origin: { x: 1, y: 1 },
  });
};
